import { render, staticRenderFns } from "./giftList.vue?vue&type=template&id=014e4db8&scoped=true&"
import script from "./giftList.vue?vue&type=script&lang=js&"
export * from "./giftList.vue?vue&type=script&lang=js&"
import style0 from "./giftList.vue?vue&type=style&index=0&id=014e4db8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014e4db8",
  null
  
)

export default component.exports